import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// Two rows of oversized text that slide in opposite directions,
// driven by scroll progress (inspired by davidlangarica.dev).
export default function ScrollBand() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  // Row 1 drifts left, Row 2 drifts right
  const xLeft = useTransform(scrollYProgress, [0, 1], ["12%", "-28%"]);
  const xRight = useTransform(scrollYProgress, [0, 1], ["-28%", "12%"]);
  const rot = useTransform(scrollYProgress, [0, 1], [-3, 3]);

  const row1 = ["Websites", "Mobile Apps", "CRM", "SaaS", "AI"];
  const row2 = ["Design", "Engineering", "Cloud", "Scale", "Product"];

  return (
    <section
      ref={ref}
      className="relative overflow-hidden border-y border-white/5 py-24 md:py-36"
    >
      <motion.div style={{ x: xLeft, rotate: rot }} className="whitespace-nowrap">
        <span className="font-display text-[13vw] font-bold uppercase leading-[0.9] text-white md:text-[9vw]">
          {row1.map((w, i) => (
            <span key={i}>
              {w}
              <span className="text-[#d4ff4e]"> / </span>
            </span>
          ))}
        </span>
      </motion.div>

      <motion.div
        style={{ x: xRight, rotate: rot }}
        className="mt-2 whitespace-nowrap md:mt-4"
      >
        <span className="font-display text-[13vw] font-bold uppercase leading-[0.9] text-transparent md:text-[9vw] [-webkit-text-stroke:1px_rgba(255,255,255,0.35)]">
          {row2.map((w, i) => (
            <span key={i}>
              {w}
              <span className="[-webkit-text-stroke:1px_#d4ff4e]"> + </span>
            </span>
          ))}
        </span>
      </motion.div>
    </section>
  );
}
